import { Code, Hint, Label, Select } from '@lokalise/louis';

import type { PlaceholderFormat } from '../../../../types';

type Option = { value: PlaceholderFormat; label: string };

interface PlaceholderFormatInputProps {
    value: PlaceholderFormat;
    options: readonly Option[];
    onChange: (value: PlaceholderFormat) => void;
}

const PlaceholderFormatInput = ({ value, options, onChange }: PlaceholderFormatInputProps) => (
    <Label
        id="PlaceholderFormatInput"
        text={
            <>
                Placeholder format{' '}
                <Hint placement="right" width={600}>
                    Select format to convert{' '}
                    <a target="_new" href="https://docs.lokalise.com/developer-docs/universal-placeholders">
                        universal placeholders
                    </a>{' '}
                    to. Example string: <Code>My name is [%s:name]. I have [%.2f] dollars.</Code>
                    <br />
                    <br />
                    <strong>Printf</strong>
                    <br />
                    <Code>My name is %s. I have %.2f dollars.</Code>
                    <br />
                    <br />
                    <strong>iOS</strong>
                    <br />
                    <Code>My name is %@. I have %.2f dollars.</Code>
                    <br />
                    <br />
                    <strong>ICU</strong>
                    <br />
                    <Code>
                        My name is {'{'}name{'}'}. I have {0} dollars.
                    </Code>
                    <br />
                    <br />
                    <strong>NET</strong>
                    <br />
                    <Code>
                        My name is {0}. I have {'{'}0:0.00{'}'} dollars.
                    </Code>
                    <br />
                    <br />
                    <strong>Symfony</strong>
                    <br />
                    <Code>My name is %name%. I have %placeholder_1% dollars.</Code>
                    <br />
                    <br />
                    <strong>i18n</strong>
                    <br />
                    <Code>
                        My name is {'{'}% verbatim %{'}'}
                        {'{'}
                        {'{'}name{'}'}
                        {'}'}. I have {'{'}
                        {'{'}0{'}'}
                        {'}'}
                        {'{'}% endverbatim %{'}'} dollars.
                    </Code>
                    <br />
                    <br />
                    <strong>Raw</strong>
                    <br />
                    No processing will be applied.
                    <br />
                    <br />
                </Hint>
            </>
        }
    >
        <Select
            aria-labelledby="PlaceholderFormatInput"
            value={options.filter((item) => value === item.value)[0]}
            options={options}
            onChange={(val) => {
                if (val === null) {
                    return;
                }
                onChange(val.value);
            }}
        />
    </Label>
);
export default PlaceholderFormatInput;
